import useFetch from './fetch';

export default function useGetUsers() {
    const fetch = useFetch();
    return () => { return fetch(`/api/user/view`).then(x => x.json()) };
};
